import React, { } from 'react';

import { Layout } from 'antd';
import './index.css';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../common/Context';
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('ru');

var _ = require('lodash');
const { Header } = Layout;

const FedSubheader = (props) => {
	const { layout, fullwidth, children } = props;
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
    const isMobile = useIsMobileContext();
    const isDesktopOrLaptop = useIsDesktopOrLaptopContext();
	let fwHeader = (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, padding: "0", margin: "0 auto" };
	let lsDiv = { lineHeight: "46px", height: "100%" };

	return (
		<Header className="subheader" style={{ padding: "0 10px", background: "#fff", height: "46px", borderRadius: "4px", ...fwHeader }}>
			<div style={{ ...lsDiv }}>
				{children}
			</div>
			<div style={{ float: 'right', ...lsDiv }}>
				{/* <DropdownAction menuOptions={{ className: "page-menu" }} trigger={['click']} placement="bottomRight" button={() => (
					<Button style={{ padding: "0 10px", marginRight: "10px", ...lsButton }} type="link">
						<MenuOutlined />
					</Button>)}>
					<MenuItem key="2" onClick={changeFullwidth}>
						<div style={{ minWidth: "200px", display: "flex", justifyContent: "space-between" }}>
							<div style={{ flex: "1" }}>
								{!fullwidth ?
									<><FullscreenOutlined />Во весь экран </> :
									<><FullscreenExitOutlined />Уменьшить </>}
							</div>
						</div>
					</MenuItem>
				</DropdownAction> */}
			</div>
		</Header>
	);
};

export default React.memo(FedSubheader);